import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 4H2v16h20V4zm-2 4-8 5-8-5V6l8 5 8-5v2z",
  fill: "currentColor"
}));
export default SvgMail;